// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:acd67bd2-1d29-48e2-aad9-a535ca94aa88',
    'aws_cognito_region': 'us-east-1',
    'aws_mobile_analytics_app_id': '7bb77e0c61a3421f9d804e9df689458e',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '740156bb-b577-4672-94d4-e441dbf59619',
    'aws_project_name': 'QuickPicksProd',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'quickpicksprod-mobilehub-1223500412',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'livegamedata.quickpicks.com',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_Dc0JWYSF4',
    'aws_user_pools_web_client_id': '4ti0bck89t4eklesjjtgnv4ftc',
}

export default awsmobile;
